import { message } from "antd";
import { Ticket } from "../ticket";
import { ticketsDataDTO } from "./helpers";
import { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { UseLazyApiCallV2 } from "hooks/use-lazy-api-call-v2";
import { TicketDetailModal } from "../ticket-detail-modal";
import { ticketStatusConversion } from "./constants";
import styles from "./styles.module.scss";

export const DraggableContext = ({ tickets, refetchTicketsData }: any) => {
  const [data, setData] = useState<any>({});
  const [ticketData, setTicketData] = useState<any>({});
  const [showTicketDetailModal, setShowTicketDetailModal] =
    useState<boolean>(false);

  const [updateTicketStatus, { isLoading }] = UseLazyApiCallV2({
    url: null,
    method: "POST",
  }) as any;

  useEffect(() => {
    let initialDataObj = ticketsDataDTO(tickets);

    setData(initialDataObj);
  }, [tickets]);

  function handleCloseModal() {
    setTicketData({});
    setShowTicketDetailModal(false);
  }
  function handleOpenModal() {
    setShowTicketDetailModal(true);
  }

  async function handleUpdateStatus({ value, ticketId }: any) {
    const endPoint = "/update_ticket_status";

    try {
      const res = await updateTicketStatus({
        url: endPoint,
        params: {
          ticket_id: ticketId,
          status: value,
        },
      });
      if (res) {
        const { success, message: apiMessage } = res || {};
        refetchTicketsData();
        return success
          ? message.success(apiMessage)
          : message.error(apiMessage);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const onDragEnd = (result: any) => {
    const { destination, source, draggableId } = result || {};

    if (!destination) return;

    const status = ticketStatusConversion[destination["droppableId"]];

    handleUpdateStatus({
      ticketId: draggableId,
      value: status,
    });

    // if (
    //   destination.droppableId === source.droppableId &&
    //   destination.index === source.index
    // ) {
    //   return;
    // }

    // const start = data.columns[source.droppableId];
    // const finish = data.columns[destination.droppableId];

    // if (start === finish) {
    //   const newTicketIds = Array.from(start.ticketIds);
    //   newTicketIds.splice(source.index, 1);
    //   newTicketIds.splice(destination.index, 0, draggableId);

    //   const newColumn = {
    //     ...start,
    //     ticketIds: newTicketIds,
    //   };

    //   const newState = {
    //     ...data,
    //     columns: {
    //       ...data.columns,
    //       [newColumn.id]: newColumn,
    //     },
    //   };

    //   setData(newState);
    //   return;
    // }

    // const startTicketIds = Array.from(start.ticketIds);
    // startTicketIds.splice(source.index, 1);
    // const newStart = {
    //   ...start,
    //   ticketIds: startTicketIds,
    // };

    // const finishTicketIds = Array.from(finish.ticketIds);
    // finishTicketIds.splice(destination.index, 0, draggableId);
    // const newFinish = {
    //   ...finish,
    //   ticketIds: finishTicketIds,
    // };

    // const newState = {
    //   ...data,
    //   columns: {
    //     ...data.columns,
    //     [newStart.id]: newStart,
    //     [newFinish.id]: newFinish,
    //   },
    // };

    // setData(newState);
  };

  return (
    <div className={styles.columnsContainer}>
      <DragDropContext onDragEnd={onDragEnd}>
        {data?.columnOrder?.map((columnId: any) => {
          const column = data.columns[columnId];

          const tickets = column?.ticketIds?.length
            ? column.ticketIds.map((ticketId: any) => data.tickets[ticketId])
            : [];

          return (
            <Droppable key={column.id} droppableId={column.id}>
              {(provided: any) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className={styles.ticketsCol}
                >
                  <div
                    className={styles.header}
                    style={{ borderBottom: `3px solid ${column?.color}` }}
                  >
                    <span
                      className={styles.circle}
                      style={{ backgroundColor: column?.color }}
                    ></span>
                    <h3 style={{ padding: "8px" }}>{column.title}</h3>
                    <span className={styles.count}>{tickets?.length}</span>
                  </div>
                  <div className={styles.ticketsContainer}>
                    {tickets?.map((ticket: any, index: any) => (
                      <Draggable
                        key={ticket?.ticket_id}
                        draggableId={ticket?.ticket_id}
                        index={index}
                      >
                        {(provided: any) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                            }}
                            className={styles.ticketWrapper}
                          >
                            <Ticket
                              ticketData={ticket}
                              handleUpdateStatus={handleUpdateStatus}
                              handleOpenModal={handleOpenModal}
                              setTicketData={setTicketData}
                            />
                          </div>
                        )}
                      </Draggable>
                    ))}
                  </div>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          );
        })}
      </DragDropContext>
      <TicketDetailModal
        showTicketDetailModal={showTicketDetailModal}
        handleCloseModal={handleCloseModal}
        ticketData={ticketData}
        refetchTicketsData={refetchTicketsData}
      />
    </div>
  );
};
